class ProjectConst {
    static Inventory = 'module-project-inventory';
    static Refresh = 'refresh';
    static Property = 'property';
    static Tower = 'tower';
    static Contact = 'contact';
    static Document = 'document';

    static SearchProperty = 'module-search-property';
    static Price = 'price';
    static PropertyTransaction = 'property_transaction';
    static PropertyType = 'property_type';
    static Type = 'type';
    static PossessionType = 'possession_type';
    static TransactionType = 'transaction_type';
    static FieldLevelSecurity = 'field_level_security';
}
export default ProjectConst;